import { render, staticRenderFns } from "./welfare-new.vue?vue&type=template&id=34e62e5c&scoped=true&lang=pug&"
import script from "./welfare-new.vue?vue&type=script&lang=js&"
export * from "./welfare-new.vue?vue&type=script&lang=js&"
import style0 from "./welfare-new.vue?vue&type=style&index=0&id=34e62e5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e62e5c",
  null
  
)

export default component.exports